import { z } from "zod";

export const WORKSPACE_ROLES = ["OWNER", "ADMIN", "MANAGER", "MEMBER", "GUEST"] as const;
export type WorkspaceRole = (typeof WORKSPACE_ROLES)[number];
export const workspaceRoleSchema = z.enum(WORKSPACE_ROLES);

/** Roles that can be granted through an invitation or a role change (OWNER only via transfer). */
export const ASSIGNABLE_ROLES = [
  "ADMIN",
  "MANAGER",
  "MEMBER",
  "GUEST",
] as const satisfies readonly WorkspaceRole[];
export type AssignableRole = (typeof ASSIGNABLE_ROLES)[number];
export const assignableRoleSchema = z.enum(ASSIGNABLE_ROLES);

export const WORKSPACE_ROLE_RANK: Readonly<Record<WorkspaceRole, number>> = {
  OWNER: 50,
  ADMIN: 40,
  MANAGER: 30,
  MEMBER: 20,
  GUEST: 10,
};

export const WORKSPACE_ROLE_LABELS: Readonly<Record<WorkspaceRole, string>> = {
  OWNER: "Owner",
  ADMIN: "Admin",
  MANAGER: "Manager",
  MEMBER: "Member",
  GUEST: "Guest",
};

export function outranks(actor: WorkspaceRole, target: WorkspaceRole): boolean {
  return WORKSPACE_ROLE_RANK[actor] > WORKSPACE_ROLE_RANK[target];
}
